"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsEnrichmentProcessing = exports.getIsEnrichmentRequestFailed = exports.getIsEnrichmentSuccessful = exports.getIsEnrichmentFinished = exports.getEnrichmentStatus = exports.getEnrichmentId = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

/**
 * Get contact enrichment id.
 *
 * @param {object} state - Application redux state.
 * @returns {number|null} - If contact enrichment has been processed will return id, otherwise - null.
 */
var getEnrichmentId = R.path(['createGift', 'contactEnrichment', 'id']);
/**
 * Get contact enrichment status.
 *
 * @param {object} state - Application redux state.
 * @returns {string} - Contact enrichment status.
 */

exports.getEnrichmentId = getEnrichmentId;
var getEnrichmentStatus = R.path(['createGift', 'contactEnrichment', 'status']);
/**
 * Is contact links researching finished successfully.
 *
 * @param {object} state - Application redux state.
 */

exports.getEnrichmentStatus = getEnrichmentStatus;
var getIsEnrichmentFinished = (0, _reselect.createSelector)(getEnrichmentStatus, function (status) {
  return ['failed', 'processed'].includes(status);
});
/**
 * Get is enrichment finished successfully.
 *
 * @param {object} state - Application redux state.
 * @returns {boolean} - True - if finished successfully, otherwise - false.
 */

exports.getIsEnrichmentFinished = getIsEnrichmentFinished;
var getIsEnrichmentSuccessful = R.pathEq(['createGift', 'contactEnrichment', 'status'], 'processed');
/**
 * Is contact links researching has been failed.
 *
 * @param {object} state - Application redux state.
 * @returns {boolean} - Is enrichment ended with error.
 */

exports.getIsEnrichmentSuccessful = getIsEnrichmentSuccessful;
var getIsEnrichmentRequestFailed = R.pathEq(['createGift', 'contactEnrichment', 'status'], 'rejected');
/**
 * Is contact links researching in processing state.
 *
 * @param {object} state - Application redux state.
 * @returns {boolean} - Is enrichment started.
 */

exports.getIsEnrichmentRequestFailed = getIsEnrichmentRequestFailed;
var getIsEnrichmentProcessing = R.pathEq(['createGift', 'contactEnrichment', 'status'], 'awaiting');
exports.getIsEnrichmentProcessing = getIsEnrichmentProcessing;